unit City;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, WEBLib.Buttons, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCBitmapContainer;

type
  TfrmCity = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebPanel4: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    dgCity: TTMSFNCDataGrid;
    wcCity: TXDataWebClient;
    wdsCity: TXDataWebDataSet;
    dsCity: TDataSource;
    dgdbaCity: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCBitmapContainer1: TTMSFNCBitmapContainer;
    WebButton2: TButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    edtCityPC: TEdit;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    wdsCityno: TIntegerField;
    wdsCityName: TStringField;
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure dgCityCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
  private
    { Private declarations }

    iCityPC , iCityMaxPC : Integer;

    procedure LoadCity;
  public
    { Public declarations }
    sCity : String;
    iCityNo : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmCity: TfrmCity;

implementation

{$R *.dfm}
uses
  share.common, share.classes, stfmssystem.connection, CitySetup;

procedure TfrmCity.dgCityCellClick(Sender: TObject; AColumn, ARow: Integer);
begin
  sCity := dgdbaCity.FieldAtColumn[1].AsString;
  iCityNo := dgdbaCity.FieldAtColumn[0].AsInteger;
end;

procedure TfrmCity.LoadCity;
procedure OnError(Error: TXDataClientError);
    begin
      LoadCity;
    end;

procedure OnSuccess(Response : TXDataClientResponse);

    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadCity;
        end
      else
        begin
          wdsCity.Close;
          wdsCity.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsCity.Open;
        end;
    end;

  procedure OnSuccessPC(Response : TXDataClientResponse);
    var
    CityParams : TCityParams;
    sCityJson : String;
    begin
      iCityMaxPC := Integer(TJSObject(Response.Result)['value']);

      edtCityPC.Text := IntToStr(iCityPC) + ' of ' + IntToStr(iCityMaxPC);

      CityParams := TCityParams.Create;
      CityParams.PageCount := iCityPC;

      sCityJson := ConvertObjToJson(CityParams).ToJSON;

      wcCity.RawInvoke('IstfmsloadsService.Get_City_View',[sCityJson],@OnSuccess,@OnError);
    end;

begin
  wcCity.RawInvoke('IstfmsloadsService.Get_City_MaxPC',[],@OnSuccessPC,@OnError);
end;

procedure TfrmCity.WebButton1Click(Sender: TObject);
begin
  sCity := '';
  iCityNo := 0;
  Close;
end;

procedure TfrmCity.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmCity.WebFormShow(Sender: TObject);
begin
  iCityPC := 1;

  LoadCity;
end;

procedure TfrmCity.WebSpeedButton5Click(Sender: TObject);
var
  sCity : String;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('City Successfully Saved');
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);

    end;
begin
  sCity := InputBox('City','Enter a new City','');

  wdsCity.Insert;
  wdsCity.FieldByName('Name').AsString := sCity;

  wcCity.RawInvoke('IstfmsloadsService.Put_City_Insert',[GetJsonFromDataSet(wdsCity)],@OnSuccess,@OnError);
end;

procedure TfrmCity.WebSpeedButton6Click(Sender: TObject);
begin
  iCityPC := 1;

  LoadCity;
end;

procedure TfrmCity.WebSpeedButton7Click(Sender: TObject);
begin
  if iCityPC > 1 then
    Begin
      Dec(iCityPC);

      LoadCity;
    End;
end;

procedure TfrmCity.WebSpeedButton8Click(Sender: TObject);
begin
  if iCityPC < iCityMaxPC then
    Begin
      Inc(iCityPC);

      LoadCity;
    End;
end;

procedure TfrmCity.WebSpeedButton9Click(Sender: TObject);
begin
  iCityPC := iCityMaxPC;

  LoadCity;
end;

procedure TfrmCity.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  TMSFNCBitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  edtCityPC := TEdit.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  dgCity := TTMSFNCDataGrid.Create(Self);
  dgdbaCity := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcCity := TXDataWebClient.Create(Self);
  wdsCity := TXDataWebDataSet.Create(Self);
  wdsCityno := TIntegerField.Create(Self);
  wdsCityName := TStringField.Create(Self);
  dsCity := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  TMSFNCBitmapContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  edtCityPC.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  dgCity.BeforeLoadDFMValues;
  dgdbaCity.BeforeLoadDFMValues;
  wcCity.BeforeLoadDFMValues;
  wdsCity.BeforeLoadDFMValues;
  wdsCityno.BeforeLoadDFMValues;
  wdsCityName.BeforeLoadDFMValues;
  dsCity.BeforeLoadDFMValues;
  try
    Name := 'frmCity';
    Width := 641;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 641;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 641;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'City Information';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    TMSFNCBitmapContainer1.SetParentComponent(WebPanel2);
    TMSFNCBitmapContainer1.Name := 'TMSFNCBitmapContainer1';
    TMSFNCBitmapContainer1.Left := 520;
    TMSFNCBitmapContainer1.Top := 24;
    TMSFNCBitmapContainer1.Width := 26;
    TMSFNCBitmapContainer1.Height := 26;
    TMSFNCBitmapContainer1.Visible := True;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 420;
    WebPanel3.Width := 641;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 115;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Close';
    WebButton1.Color := clSkyBlue;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 13;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Select';
    WebButton2.Color := clGreenyellow;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 240;
    WebSpeedButton6.Top := 16;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := '<<';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 2;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton7.SetParentComponent(WebPanel3);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 270;
    WebSpeedButton7.Top := 16;
    WebSpeedButton7.Width := 24;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := '<';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 3;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    edtCityPC.SetParentComponent(WebPanel3);
    edtCityPC.Name := 'edtCityPC';
    edtCityPC.Left := 300;
    edtCityPC.Top := 16;
    edtCityPC.Width := 60;
    edtCityPC.Height := 22;
    edtCityPC.Alignment := taCenter;
    edtCityPC.ChildOrder := 7;
    edtCityPC.HeightPercent := 100.000000000000000000;
    edtCityPC.Text := '1 of 1';
    edtCityPC.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel3);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 366;
    WebSpeedButton8.Top := 16;
    WebSpeedButton8.Width := 24;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := '>';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 5;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton9.SetParentComponent(WebPanel3);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 396;
    WebSpeedButton9.Top := 16;
    WebSpeedButton9.Width := 24;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := '>>';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 6;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 60;
    WebPanel4.Width := 641;
    WebPanel4.Height := 53;
    WebPanel4.Align := alTop;
    WebPanel4.ChildOrder := 2;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(WebPanel4);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 16;
    WebSpeedButton1.Top := 6;
    WebSpeedButton1.Width := 40;
    WebSpeedButton1.Height := 40;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    WebSpeedButton2.SetParentComponent(WebPanel4);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 62;
    WebSpeedButton2.Top := 6;
    WebSpeedButton2.Width := 40;
    WebSpeedButton2.Height := 40;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    WebSpeedButton3.SetParentComponent(WebPanel4);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 108;
    WebSpeedButton3.Top := 6;
    WebSpeedButton3.Width := 40;
    WebSpeedButton3.Height := 40;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    WebSpeedButton4.SetParentComponent(WebPanel4);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 154;
    WebSpeedButton4.Top := 6;
    WebSpeedButton4.Width := 40;
    WebSpeedButton4.Height := 40;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    WebSpeedButton5.SetParentComponent(WebPanel4);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 200;
    WebSpeedButton5.Top := 6;
    WebSpeedButton5.Width := 40;
    WebSpeedButton5.Height := 40;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    dgCity.SetParentComponent(WebPanel1);
    dgCity.Name := 'dgCity';
    dgCity.Left := 0;
    dgCity.Top := 113;
    dgCity.Width := 641;
    dgCity.Height := 307;
    dgCity.Align := alClient;
    dgCity.ParentDoubleBuffered := False;
    dgCity.DoubleBuffered := True;
    dgCity.TabOrder := 3;
    dgCity.ShowAcceleratorChar := False;
    dgCity.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgCity.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgCity.Header.VisualGrouping.Layout.Font.Height := -12;
    dgCity.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgCity.Header.VisualGrouping.Layout.Font.Style := [];
    dgCity.Adapter := dgdbaCity;
    dgCity.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgCity.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgCity.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgCity.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgCity.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.BandLayout.Font.Height := -12;
    dgCity.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.BandLayout.Font.Style := [];
    dgCity.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.FixedLayout.Font.Height := -12;
    dgCity.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.FixedLayout.Font.Style := [];
    dgCity.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgCity.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgCity.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.FocusedLayout.Font.Height := -12;
    dgCity.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.FocusedLayout.Font.Style := [];
    dgCity.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.GroupLayout.Font.Height := -12;
    dgCity.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.GroupLayout.Font.Style := [];
    dgCity.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.NormalLayout.Font.Height := -12;
    dgCity.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.NormalLayout.Font.Style := [];
    dgCity.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.SelectedLayout.Font.Height := -12;
    dgCity.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.SelectedLayout.Font.Style := [];
    dgCity.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgCity.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgCity.CellAppearance.SummaryLayout.Font.Height := -12;
    dgCity.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgCity.CellAppearance.SummaryLayout.Font.Style := [];
    dgCity.ColumnCount := 2;
    dgCity.Columns.Clear;
    with dgCity.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'no';
    end;
    with dgCity.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
    end;
    dgCity.Designer := False;
    dgCity.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgCity.FilterAppearance.Font.Color := clWindowText;
    dgCity.FilterAppearance.Font.Height := -12;
    dgCity.FilterAppearance.Font.Name := 'Segoe UI';
    dgCity.FilterAppearance.Font.Style := [];
    dgCity.Icons.ExpandIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.ExpandIcon.svg');
    dgCity.Icons.CollapseIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.CollapseIcon.svg');
    dgCity.Icons.FilterIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.FilterIcon.svg');
    dgCity.Icons.FilterActiveIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.FilterActiveIcon.svg');
    dgCity.Icons.FilterClearIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.FilterClearIcon.svg');
    dgCity.Icons.FilterTypeIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.FilterTypeIcon.svg');
    dgCity.Icons.SortAscendingIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.SortAscendingIcon.svg');
    dgCity.Icons.SortDescendingIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.SortDescendingIcon.svg');
    dgCity.Icons.CloseIcon.LoadFromFile('City.WebPanel1.dgCity.Icons.CloseIcon.svg');
    SetEvent(dgCity, Self, 'OnCellClick', 'dgCityCellClick');
    dgCity.RowCount := 1;
    dgdbaCity.SetParentComponent(dgCity);
    dgdbaCity.Name := 'dgdbaCity';
    dgdbaCity.Left := 272;
    dgdbaCity.Top := 56;
    dgdbaCity.Width := 26;
    dgdbaCity.Height := 26;
    dgdbaCity.Visible := True;
    dgdbaCity.Columns.Clear;
    with dgdbaCity.Columns.Add do
    begin
      FieldName := 'no';
      Header := 'no';
      AutoCreated := False;
    end;
    with dgdbaCity.Columns.Add do
    begin
      FieldName := 'Name';
      Header := 'Name';
      AutoCreated := False;
    end;
    dgdbaCity.DataSource := dsCity;
    wcCity.SetParentComponent(Self);
    wcCity.Name := 'wcCity';
    wcCity.Connection := dmData.dbConnect;
    wcCity.Left := 88;
    wcCity.Top := 169;
    wdsCity.SetParentComponent(Self);
    wdsCity.Name := 'wdsCity';
    wdsCity.Connection := dmData.dbConnect;
    wdsCity.Left := 152;
    wdsCity.Top := 169;
    wdsCityno.SetParentComponent(wdsCity);
    wdsCityno.Name := 'wdsCityno';
    wdsCityno.FieldName := 'no';
    wdsCityName.SetParentComponent(wdsCity);
    wdsCityName.Name := 'wdsCityName';
    wdsCityName.FieldName := 'Name';
    dsCity.SetParentComponent(Self);
    dsCity.Name := 'dsCity';
    dsCity.DataSet := wdsCity;
    dsCity.Left := 216;
    dsCity.Top := 169;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    TMSFNCBitmapContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    edtCityPC.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    dgCity.AfterLoadDFMValues;
    dgdbaCity.AfterLoadDFMValues;
    wcCity.AfterLoadDFMValues;
    wdsCity.AfterLoadDFMValues;
    wdsCityno.AfterLoadDFMValues;
    wdsCityName.AfterLoadDFMValues;
    dsCity.AfterLoadDFMValues;
  end;
end;

end.